import memoize from 'memoizee';
import { debounce } from 'lodash';
import { updateSceneOptimistic } from '../../../api/configuratorApi';
import { dispatcher } from '../../../helpers/projectHelper';
import { waitForEventOnce } from '../../../helpers/unityPubSub';
import {
  configuratorActions,
  selectConfiguratorData,
  // selectBaseMaterialData,
  selectIsUnityInitializing,
  selectSceneById,
  // selectSelectedOption,
  selectSelectedSceneId,
  selectUnitySceneLoaded,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { getAppState } from '../../../redux/store';
import { CONFIGURATOR_UNITY_EVENT } from '../unity/unityCallbacks';
import { configuratorModule } from '../unity/unityMethods';
import { ONE_MINUTE, ONE_SECOND } from '../../../constants/constants';
import { getSceneJson } from '../unity/initUnity';

export const saveSceneJson = async ({ reason, delayed = true } = {}) => {
  const isUnityInitializing = selectIsUnityInitializing(getAppState());
  // const baseMaterialData = selectBaseMaterialData(getAppState());
  // const selectedOption = selectSelectedOption(getAppState());
  const unitySceneLoaded = selectUnitySceneLoaded(getAppState());
  if (isUnityInitializing || !unitySceneLoaded) {
    // we don't want to update scene json when unity initialization is in progress
    return;
  }
  const sceneId = selectSelectedSceneId(getAppState());
  const configuratorData = selectConfiguratorData(getAppState());
  const isPreviewRenderCreated =
    configuratorData?.is_preview_created || configuratorData?.is_render_created;
  const oldSceneJson = await getSceneJson(sceneId, false);
  const sceneJson = await waitForEventOnce(CONFIGURATOR_UNITY_EVENT.GetRoomInfo, () =>
    configuratorModule.GetConfiguratorJson()
  );
  const sceneCopyData = JSON.parse(JSON.stringify(sceneJson));
  // sceneCopyData.selectedOption = selectedOption || {};
  // sceneCopyData.baseMaterialData = baseMaterialData || {};
  sceneCopyData.deletedObjectsData =
    sceneCopyData?.deletedObjectData || sceneCopyData?.deletedObjectsData || [];
  delete sceneCopyData?.deletedObjectData;
  // update data in redux right away
  if (isPreviewRenderCreated) {
    sceneCopyData.screenWidth = oldSceneJson?.screenWidth;
    sceneCopyData.screenHeight = oldSceneJson?.screenHeight;
    sceneCopyData.cameraAspect = oldSceneJson?.cameraAspect;
  }
  dispatcher(
    configuratorActions.updateScene({
      id: sceneId,
      json_file_content: sceneCopyData,
    })
  );
  // we have some delay before we save data on server
  const debouncedSaveScene = getDebouncedSaveScene(sceneId);
  if (delayed) {
    debouncedSaveScene(sceneCopyData);
  } else {
    debouncedSaveScene.cancel();
    const saveResult = await saveData(sceneId, sceneCopyData);
    return saveResult;
  }
};

const saveData = (sceneId, sceneJson) => {
  const scene = selectSceneById(sceneId)(getAppState());
  const isUnityInitializing = selectIsUnityInitializing(getAppState());
  const unitySceneLoaded = selectUnitySceneLoaded(getAppState());
  if (!scene || isUnityInitializing || !unitySceneLoaded) return;
  return dispatcher(updateSceneOptimistic({ id: sceneId, json_file_content: sceneJson }));
};

const getDebouncedSaveScene = memoize(
  (sceneId) => {
    return debounce((sceneJson) => {
      saveData(sceneId, sceneJson);
    }, 3 * ONE_SECOND);
  },
  { length: 1, maxAge: 2 * ONE_MINUTE }
);

export const saveSceneJsonWithDelay300 = debounce(saveSceneJson, 300);
export const saveSceneJsonWithDelay500 = debounce(saveSceneJson, 500);
export const saveSceneJsonWithDelay1000 = debounce(saveSceneJson, 1000);
